import App from 'App';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getIsOnline } from 'store/connection';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as loginAC, getHasAuthenticationLoaded, getIsAuthenticated } from 'store/login';
import {
	actionCreators as profileAC,
	getIsAnamnesisDone,
	getIsLoadingProfile,
	getIsProfileLoaded,
} from 'store/profile';
import { actionCreators as routerAC } from 'store/router';
import { actionCreators as viewAC, getCurrentViewID } from 'store/view';

export type AppPropsType = {
	currentViewID: string;
	isLoadingProfile: boolean;
	isProfileLoaded: boolean;
	isAuthenticated: boolean;
	hasAuthenticationLoaded: boolean;
	isAnamneseDone: boolean;
};

const mapStateToProps = (state): AppPropsType & any => ({
	currentViewID: getCurrentViewID(state)!,
	isOnline: getIsOnline(state),
	isLoadingProfile: getIsLoadingProfile(state)!,
	isProfileLoaded: getIsProfileLoaded(state)!,
	isAuthenticated: getIsAuthenticated(state),
	hasAuthenticationLoaded: getHasAuthenticationLoaded(state),
	isAnamneseDone: getIsAnamnesisDone(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doLoadUserData: profileAC.doLoadUserData,
			doRequestCustomOverlays: eventsAC.doRequestCustomOverlays,
			doSaveRedirectRoutePath: loginAC.doSaveRedirectRoutePath,
			doChangeViewID: viewAC.doChangeViewID,
			doOpenOffCanvas: viewAC.doOpenOffCanvas,
			doCloseOffCanvas: viewAC.doCloseOffCanvas,
			doStoreRouterHistory: routerAC.doStoreRouterHistory,
		},
		dispatch
	);
};

export default connect<ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, any>(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(App as any));
